import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class IsAuthorizedService {
  public isAuthorized = new BehaviorSubject<boolean>(false);

  constructor() {
  }

}
